<div class="grid-1">
  <app-card>
    <div class="grid-5">
      <div class="col-span-3">
        <div class="text-heading">
          <app-icon icon="circle-exclamation" type="solid"></app-icon>
          Storing | Digitale televisie via coax (DVB-C), Interactive televisie | Landelijk
        </div>
        <div class="text-subtitle">
          Momenteel ondervinden wij een verstoring met het digitale televisie signaal via coax (DVB-C) en Interactive
          televisie. Hierdoor kan het voorkomen dat u geen beeld heeft op uw televisie. Wij werken aan een oplossing.
          Onze excuses voor het ongemak.
        </div>
      </div>
      <div></div>
      <div class="text-subtitle">
        <p>
          <b>Status</b>: aangemeld
        </p>
        <p>
          <b>Aanvang</b>: 12-12-2020 om 12:00 uur
        </p>
        <p>
          <b>Afgerond</b>: 12-12-2020 om 12:00 uur
        </p>
      </div>
    </div>
  </app-card>
  <app-card>
    <div class="grid-5">
      <div class="col-span-3">
        <div class="text-heading">
          <app-icon icon="wrench" type="solid"></app-icon>
          Storing | Digitale televisie via coax (DVB-C), Interactive televisie | Landelijk
        </div>
        <div class="text-subtitle">
          Momenteel ondervinden wij een verstoring met het digitale televisie signaal via coax (DVB-C) en Interactive
          televisie. Hierdoor kan het voorkomen dat u geen beeld heeft op uw televisie. Wij werken aan een oplossing.
          Onze excuses voor het ongemak.
        </div>
      </div>
      <div class="col-span-1"></div>
      <div class="text-subtitle">
        <p>
          <b>Abonnementsnummer</b>: 1337
        </p>
        <p>
          <b>Status</b>: aangemeld
        </p>
        <p>
          <b>Aanvang</b>: 12-12-2020 om 12:00 uur
        </p>
        <p>
          <b>Afgerond</b>: 12-12-2020 om 12:00 uur
        </p>
      </div>

      <div class="timeline col-span-2">
        @for (timelineEntry of this.timelineEntries; track timelineEntry; let i = $index) {
          <div class="entry">
            @if (this.timelineEntries.length !== (i + 1)) {
              <div class="line"></div>
            }
            <div class="text-heading">
              <app-icon icon="circle" [type]="i === 0 ? 'regular' : 'thin'"></app-icon>
              Update op {{ timelineEntry.date | date: 'dd-MM-yyyy' }} om {{ timelineEntry.date | date: 'HH:mm' }} uur:
            </div>
            <div class="text-subtitle">{{ timelineEntry.description }}</div>
          </div>
        }

      </div>
    </div>
  </app-card>
</div>
